import { z } from 'zod'

import { MessageMediaSchema } from '@/modules/message/service/message-service'

import type { Creator } from '../creators/types'

export const ScriptBaseSchema = z.object({
  id: z.number(),
  name: z.string(),
  message: z
    .object({
      id: z.number(),
      text: z.string(),
      fallback: z.string().nullish(),
      fallbackVariable: z.string().nullish(),
      enableFallbackVariable: z.boolean(),
      medias: z.array(MessageMediaSchema).optional().nullish(),
      price: z.number(),
    })
    .nullish()
    .optional(),
  orderNumber: z.number(),
  categoryId: z.number().optional(),
})

export type ScriptNode = z.infer<typeof ScriptBaseSchema> & {
  scripts?: ScriptNode[]
}

export const ScriptSchema: z.ZodType<ScriptNode> = ScriptBaseSchema.extend({
  scripts: z.lazy(() => ScriptSchema.array().optional()),
})

export interface MovingScriptsIds {
  [categoryId: number]: number[]
}

export const ScriptListResponseSchema = z.object({
  categories: z.array(ScriptSchema),
})

export const CreateScriptSchema = z.object({
  name: z.string(),
  category: z.number().nullish(),
  message: z.object({
    text: z.string(),
    fallback: z.string().nullish(),
    fallbackVariable: z.string().nullish(),
    enableFallbackVariable: z.boolean(),
    medias: z.array(MessageMediaSchema).optional().nullish(),
    price: z.number().optional().nullable(),
  }),
})

export const EditScriptSchema = CreateScriptSchema.extend({
  id: z.number(),
})

export type CreateScriptType = z.infer<typeof CreateScriptSchema>

export type EditScriptType = z.infer<typeof EditScriptSchema>

export const CreateCategorySchema = z.object({
  name: z.string(),
})

export type CategoryCreateType = z.infer<typeof CreateCategorySchema>

export interface CopyScriptsOptions {
  originCreatorId: Creator['id']
  targetCreatorIds: Creator['id'][]
  folders: {
    id: ScriptNode['id']
    scriptIds: ScriptNode['id'][]
  }[]
}
